export default {
  default_program_name: 'Klub nagród',
  message:
    'Dołącz do <highlight>{{name}}</highlight> — zdobywaj {{reward}} za każde wydane {{spend}} i odblokowuj darmowe produkty!',
  buttons: {
    join_now: 'Dołącz teraz',
  },
};
